import React from "react";
import PageHeader from "../components/PageHeader";
import Reveal from "../components/Reveal";

export default function Privacy() {
  return (
    <div data-testid="page-privacy">
      <PageHeader eyebrow="Legal" title="Privacy" accent="Policy" />
      <section className="max-w-3xl mx-auto px-4 md:px-8 pb-20 prose prose-invert text-white/75 leading-relaxed">
        <Reveal>
          <p>Last updated: {new Date().toLocaleDateString("en-AU", { year: "numeric", month: "long", day: "numeric" })}</p>

          <h2 className="text-2xl font-extrabold mt-8">Information we collect</h2>
          <p>When you use the Taste of Egg website, we may collect: your name, email, phone number and any message you send via our contact form. We use this information solely to respond to your enquiry, manage catering bookings, and improve our services.</p>

          <h2 className="text-2xl font-extrabold mt-8">How we use it</h2>
          <p>We never sell your data. We use it to reply to your enquiry, send you booking confirmations, and (only if you opt in) keep you updated on truck locations and specials.</p>

          <h2 className="text-2xl font-extrabold mt-8">Cookies & analytics</h2>
          <p>We use minimal first-party analytics to understand which dishes and pages are most popular, so we can keep improving the experience. No personal identifying information is shared with third parties.</p>

          <h2 className="text-2xl font-extrabold mt-8">Your rights</h2>
          <p>You can request a copy of, correction to, or deletion of your data at any time by emailing <a href="mailto:info@tasteofegg.com.au" className="text-yellow-brand">info@tasteofegg.com.au</a>.</p>

          <h2 className="text-2xl font-extrabold mt-8">Contact</h2>
          <p>For any privacy questions, email us at info@tasteofegg.com.au or call 0434 508 712.</p>
        </Reveal>
      </section>
    </div>
  );
}
